import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { ListItem, Menu } from '@material-ui/core'
import { setSelectedFilters } from 'reducers/lookupTables/reducer'
import {
  FILTER_TYPE_DATE_CREATED,
  FILTER_TYPE_DATE_UPDATED,
  LOOKUP_TABLES_FILTERS,
} from 'constants/lookupTables'
import { dateToLocalISO8601DateString } from 'helpers/dates'
import messages from '../translate'

function FiltersDropdown({
  intl: { formatMessage },
  selectedFilters,
  setSelectedFilters,
  anchorEl,
  applyFilter,
  setAnchorEl,
  closeOnSelect,
}) {
  const selectedFiltersData = selectedFilters.toJS()

  const updatedFilters = LOOKUP_TABLES_FILTERS.filter(
    ({ value }) =>
      !selectedFiltersData.find(
        ({ value: selectedValue }) => selectedValue === value,
      ),
  )

  const applyDateRangeFilter = rangeFilter => {
    const formattedStartDate = dateToLocalISO8601DateString(new Date())
    const formattedEndDate = dateToLocalISO8601DateString(new Date())

    applyFilter({
      [`${rangeFilter}_from`]: formattedStartDate,
      [`${rangeFilter}_to`]: formattedEndDate,
    })
  }

  return (
    <Menu
      keepMounted
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={() => {
        setAnchorEl(null)
      }}
      className="management-ui-menu">
      <ListItem className="menu-title">
        {formatMessage(messages.addFilter)}
      </ListItem>
      {updatedFilters.map(filter => {
        const { value, label } = filter

        return (
          <ListItem
            key={value}
            onClick={() => {
              setSelectedFilters([...selectedFiltersData, filter])

              if (
                value === FILTER_TYPE_DATE_CREATED ||
                value === FILTER_TYPE_DATE_UPDATED
              ) {
                applyDateRangeFilter(value)
              }

              if (closeOnSelect) {
                setAnchorEl(null)
              }
            }}
            className="menu-item wide">
            {formatMessage(messages[label])}
          </ListItem>
        )
      })}
    </Menu>
  )
}

export default connect(
  state => ({
    selectedFilters: state.getIn(['lookupTables', 'selectedFilters']),
  }),
  { setSelectedFilters },
)(injectIntl(FiltersDropdown))
